/* Dark Dojo motion layer. Runs on every page, no dependencies. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    /* ---- scroll reveal ---- */
    var targets = document.querySelectorAll('[data-reveal]:not(.in)');
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
      targets.forEach(function (el) { io.observe(el); });
    }
  }
  init();
  /* the theme editor swaps section markup in without a reload */
  document.addEventListener('shopify:section:load', init);

  /* ---- parallax ---- */
  var ticking = false;
  function frame() {
    if (!reduced) {
      document.querySelectorAll('[data-parallax]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var mid = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (-mid * parseFloat(el.dataset.parallax)).toFixed(2) + 'px,0) scale(1.14)';
      });
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }, { passive: true });
  window.addEventListener('resize', frame);
  frame();

  /* ---- video lightbox, shared by every section ---- */
  var lb;
  function ensureLb() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<button class="lb__close" data-lb-close>Close <span aria-hidden="true">&times;</span></button>' +
      '<div class="lb__frame"></div>';
    document.body.appendChild(lb);
    return lb;
  }
  function openVideo(id) {
    var el = ensureLb();
    el.querySelector('.lb__frame').innerHTML =
      '<iframe src="https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&rel=0" allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="Video"></iframe>';
    requestAnimationFrame(function () { el.classList.add('open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeVideo() {
    if (!lb) return;
    lb.classList.remove('open');
    lb.querySelector('.lb__frame').innerHTML = '';
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-video]');
    if (t && t.dataset.video) { e.preventDefault(); openVideo(t.dataset.video); return; }
    if (e.target.closest('[data-lb-close]') || (lb && e.target === lb)) closeVideo();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') return closeVideo();
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var f = document.activeElement;
    if (f && f.classList.contains('yt')) { e.preventDefault(); openVideo(f.dataset.video); }
  });
})();

/* PDF widen toggle + docs contents highlighting */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pdf-wide]');
    if (!b) return;
    var box = b.closest('.pdf');
    b.textContent = box.classList.toggle('wide') ? 'Narrow' : 'Widen';
  });

  function spy() {
    var toc = document.querySelector('[data-dds-toc]');
    if (!toc || !('IntersectionObserver' in window)) return;
    var links = [].slice.call(toc.querySelectorAll('a'));
    var heads = links.map(function (a) { return document.getElementById(a.hash.slice(1)); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = heads.indexOf(e.target);
        links.forEach(function (l, n) { l.classList.toggle('on', n === i); });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { if (h) io.observe(h); });
  }
  spy();
  document.addEventListener('shopify:section:load', spy);
})();

/* Custom header: frost on scroll, hide on scroll down, drawer toggle */
(function () {
  'use strict';
  var nav = document.querySelector('[data-dds-nav]');
  if (!nav) return;
  var last = 0, ticking = false;

  function frame() {
    var y = window.scrollY;
    nav.classList.toggle('stuck', y > 24);
    nav.classList.toggle('hide', y > 400 && y > last && !document.body.classList.contains('menu-open'));
    last = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }, { passive: true });
  frame();

  var burger = document.querySelector('[data-dds-burger]');
  function setMenu(open) {
    document.body.classList.toggle('menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (burger) burger.setAttribute('aria-expanded', String(open));
  }
  if (burger) {
    burger.addEventListener('click', function () {
      setMenu(!document.body.classList.contains('menu-open'));
    });
  }
  document.querySelectorAll('#ddsdrawer [data-close]').forEach(function (a) {
    a.addEventListener('click', function () { setMenu(false); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
})();
